import {ReactElement} from "react"

const RightIcon = (): ReactElement => {
	return (
    <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 0.75L7.75 8.75L0.75 16.75"
        stroke="#7E8591"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default RightIcon
